<div
    [class]="suppressIframeModalChrome ? 'voucher-modal-root' : 'voucher-modal-root d-block modal fade show'"
    appVenueColour
>
    @if (venue$ | async; as venue) {
        <div
            *ngIf="!suppressIframeModalChrome"
            class="text-white small position-absolute bottom-0 d-none d-sm-flex gap-2 justify-content-center align-items-center w-100 p-3"
        >
            {{ venue.voucherDisplayName() }}
            collaborates with TableSense to simplify operations and create lasting guest experiences.
            <a
                [href]="marketingUrl"
                target="_blank"
            >
                Learn more
            </a>
        </div>
        <div [class]="suppressIframeModalChrome ? 'voucher-modal-layout' : 'voucher-modal-layout container p-0 d-flex flex-column align-items-center justify-content-center'">
            <div class="voucher-modal-panel modal-content m-0">
                <ng-container
                    *ngTemplateOutlet="header; context: { venue: venue }"
                >
                </ng-container>
                <ng-container
                    *ngTemplateOutlet="body; context: { venue: venue }"
                >
                </ng-container>
            </div>
        </div>
    }
</div>

<ng-template
    #header
    let-venue="venue"
>
    <div
        class="modal-header px-4 py-2 d-flex justify-content-between"
    >
        <h5
            class="modal-title fw-semibold"
            [title]="venue.voucherDisplayName()"
        >
            @switch (form.get('step')?.value) {
                @case (VoucherModalStep.SKUSelection) {
                    <div class="voucher-purchase-title py-1">
                        {{ venue.voucherDisplayName() }}
                    </div>
                }
                @case (VoucherModalStep.Checkout) {
                    <div class="hstack gap-3 align-items-center">
                        <button
                            type="button"
                            class="btn btn-sm btn-outline-secondary"
                            (click)="goToSKUSelection()"
                        >
                            <img
                                ngSrc="assets/left/normal.svg"
                                width="16"
                                height="16"
                            />
                        </button>
                        Checkout
                    </div>
                }
                @case (VoucherModalStep.PaymentConfirmation) {
                    <div class="py-1 hstack gap-3 align-items-center">
                        Order Received
                    </div>
                }
            }
        </h5>
        <button
            type="button"
            class="btn-close voucher-modal-close"
            aria-label="Close"
            (click)="dismiss()"
        >
        </button>
    </div>
</ng-template>

<ng-template
    #body
    let-venue="venue"
>
    @if (voucher$ | async; as voucher) {
        @switch (form.get('step')?.value) {
            @case (VoucherModalStep.SKUSelection) {
                <div class="modal-body p-0">
                    <app-voucher-selection
                        #selection
                        [venue]="venue"
                        [voucher]="voucher"
                        [form]="form"
                        (checkoutSelected)="goToCheckout(venue)"
                    >
                    </app-voucher-selection>
                </div>
                <div class="modal-footer voucher-modal-footer">
                    <ng-container *ngTemplateOutlet="selection.checkoutFooter"></ng-container>
                </div>
            }
            @case (VoucherModalStep.Checkout) {
                <div class="modal-body p-0">
                    <app-voucher-checkout
                        [venue]="venue"
                        [voucher]="voucher"
                        [form]="form"
                        (paymentConfirmed)="paymentConfirmed($event)"
                    >
                    </app-voucher-checkout>
                </div>
            }
            @case (VoucherModalStep.PaymentConfirmation) {
                <div class="modal-body p-0">
                    @if (confirmedSale) {
                        <app-voucher-payment-confirmation [venue]="venue" [voucher]="voucher" [sale]="confirmedSale">
                        </app-voucher-payment-confirmation>
                    }
                </div>
            }
        }
    } @else {
        <div class="modal-body p-0">
            <div
                class="d-flex align-items-center justify-content-center"
                data-testid="voucher-modal-loading"
                style="min-height: min(520px, calc(100vh - 140px));"
            >
                <div class="spinner-border text-secondary mb-5" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    }
</ng-template>
